import Loader from "components/DesignSystem/Loader/loader";
import { useQuery } from "hooks/useQuery";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const RedirectPage = () => {
  const query = useQuery();

  const url = query.get("url");
  const store = query.get("store");

  useEffect(() => {
    if (store) {
      try {
        localStorage.setItem("redirect_store", store);
      } catch (error) {
        console.error("Error parsing store:", error);
      }
    }

    if (url) {
      window.location.href = url;
    }
  }, [url, store]);

  return (
    <div className="t-h-screen t-w-screen t-flex t-justify-center t-items-center">
      <Loader />
    </div>
  );
};
